import { useState } from 'react';
import Reveal from '@/components/base/Reveal';

export default function Subscribe() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleClick = () => {
    if (!email.trim()) {
      setMessage('请先填写邮箱地址，方便记录你的订阅偏好。');
      return;
    }
    setMessage('演示环境：订阅请求未真实提交，正式上线后可接入邮箱服务。');
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-lg border border-accent-200 bg-accent-100/60">
            <div className="grid grid-cols-1 gap-6 p-6 md:grid-cols-[1.2fr_1fr] md:items-center md:p-10">
              <div>
                <div className="mb-2 flex items-center gap-2 text-accent-800">
                  <span className="flex h-5 w-5 items-center justify-center">
                    <i className="ri-mail-send-line" />
                  </span>
                  <span className="font-label text-xs tracking-[0.28em] uppercase">Update Reminder</span>
                </div>
                <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[30px]">
                  订阅更新提醒，新目录上线先知道
                </h2>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-foreground-700">
                  留下邮箱，我们会在索引目录更新、榜单刷新或新专题上线时提醒你。本区域仅作展示，不会真实提交。
                </p>
              </div>

              <div>
                <div className="flex h-12 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
                  <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                    <i className="ri-at-line" />
                  </span>
                  <input
                    value={email}
                    onChange={(event) => {
                      setEmail(event.target.value);
                      setMessage('');
                    }}
                    placeholder="your@email.com"
                    className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
                  />
                </div>
                <button
                  type="button"
                  onClick={handleClick}
                  className="mt-3 flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm text-background-50 whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
                >
                  <i className="ri-notification-3-line" />
                  订阅更新提醒
                </button>
                {message ? (
                  <p className="mt-3 flex items-start gap-1.5 text-xs leading-relaxed text-foreground-700">
                    <span className="flex h-4 w-4 shrink-0 items-center justify-center text-secondary-600">
                      <i className="ri-information-line" />
                    </span>
                    {message}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}